import React from 'react';
import '../styles/theme-footer.css';

interface ThemeFooterProps {
  className?: string;
}

const ThemeFooter: React.FC<ThemeFooterProps> = ({ className = '' }) => {
  return (
    <footer id="wp-colophon" className={`wp-site-footer ${className}`} role="contentinfo">
      <div className="wp-container">
        <div className="wp-footer-content">
          <div className="wp-footer-section wp-footer-main">
            {/* Kontakt */}
            <div className="wp-contact-details">
              <div className="wp-contact-item wp-contact-item--address">
                <div className="wp-contact-label"><strong>Adres:</strong></div>
                <div className="wp-contact-value">
                  ul. Wrocławska 2a<br/>
                  58-211 Uciechów, dolnośląskie
                </div>
              </div>
              <div className="wp-contact-item wp-contact-item--phone">
                <div className="wp-contact-label"><strong>Telefon:</strong></div>
                <div className="wp-contact-value wp-phone-numbers">
                  <a href="tel:+48748324690">+48 74 832 46 90</a>
                  <a href="tel:+48748310050">+48 74 831 00 50</a>
                </div>
              </div>
              <div className="wp-contact-item wp-contact-item--email">
                <div className="wp-contact-label"><strong>Email:</strong></div>
                <div className="wp-contact-value">
                  <a href="mailto:unico@unico-kominki.pl">unico@unico-kominki.pl</a>
                </div>
              </div>
            </div>
          </div>
          

        </div>
        
        {/* Copyright */}
        <div className="wp-site-info">
          <div className="wp-copyright">
            <p>&copy; 2024 UNICO. Wszelkie prawa zastrzeżone.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ThemeFooter;